import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import './styles/infoteacher.css'

//Extras
import { db } from '../assets/connections'
import { compareDates, decomposeDate, getCurrentDay, guessMonthNumb } from '../assets/validator'
import { niveles, horas, horas as hours } from '../assets/datas'
import { fontType, main } from '../assets/extras'
import { arrayRemove, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, updateDoc, where } from 'firebase/firestore'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Confirm from '../components/confirm'
import Menu from '../components/menu'

const InfoTeacher = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const data = location.state ? location.state.data : null
    const academia = location.state ? location.state.academia : null

    const [variables, setVariables] = useState({
        loading: true,
        clases: [],
        selDay: "Todos los dias",
        claseData: {},
        showData: false,
        confirm: false
    })

    //Varibles para el uso del confirm
    const [confirm, setConfirm] = useState({
        show: false,
        title: "",
        text: ""
    })
    //Varibles para el uso del confirm
    const [confirmCorte, setConfirmCorte] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Variable que almacena los datos ordenados por dias
    var sortedDaysData = [
        [], //Extras
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for (let i = 0; i < 7; i++) {
            if (i === 0) { //Lunes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Lunes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 1) { //Martes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Martes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++;
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 2) { //Miercoles
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Miercoles") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 3) { //Jueves
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Jueves") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 4) { //Viernes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Viernes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 5) { //Sabado
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Sabado") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 6) { //Domingo
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Domingo") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            }
        }
    }

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion para eliminar al profesor
    const onHandleEliminarProfesor = () => {
        setConfirm(prev => ({
            ...prev,
            show: false
        }))
        if (variables.clases.length > 0) {
            showMessage("El profesor no debe tener clases para poder ser eliminado", "warning")
        } else {
            setVariables(prev => ({
                ...prev,
                loading: true
            }))
            deletingTeacher()
        }
    }
    const deletingTeacher = async () => {
        await updateDoc(doc(db, "Profesores", data.correo_profesor), {
            ...data,
            academia_profesor: arrayRemove(academia)
        }).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage(data.nombre_profesor + " fue eliminado correctamente", "success")
                setTimeout(() => {
                    window.history.back()
                }, 1000)
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if (!sessionStorage.getItem("homeFlag") || !ref) {
            navigate("/home", { replace: true })
        } else {
            onSnapshot(query(collection(doc(db, ref), "Clases"), where("profesor_clase", "==", data.id), orderBy("nombre_clase", "asc")), r => {
                var aux = []
                var sort = niveles.map(v => []) //Obtenemos un arreglo con las listas por cada nivel
                r.docs.map(v => {
                    const id = v.id
                    if (id.split("-").length === 1) {

                        var dias_aux = []
                        v.data().dias_clase.map(v => {
                            dias_aux.push(v.dia)
                        })

                        var newObject = {
                            id: v.id,
                            nombre_clase: v.data().nombre_clase,
                            profesor_clase: v.data().profesor_clase,
                            descripcion_clase: v.data().descripcion_clase,
                            nombre_profesor: v.data().nombre_profesor,
                            dias_clase: v.data().dias_clase,
                            nivel: v.data().nivel,
                            dias: dias_aux,
                            categoria: v.data().categoria,
                            numero_jugadores: v.data().numero_jugadores,
                            limite_jugadores: v.data().limite_jugadores
                        }

                        aux.push(newObject)
                    }
                })

                //Ordenamos cada clase de la lista de las categorias por dias
                for (let i = 0; i < aux.length; i++) {
                    //Recibimos una sola clase de la lista+
                    sortByDay(aux[i])
                }

                var aux2 = []
                //Una vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
                //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
                for (let i = 0; i < sortedDaysData.length; i++) {

                    //Primero creamos una variable que contendra las horas de clase
                    var h = horas.map((v, i) => [])

                    for (let x = 0; x < sortedDaysData[i].length; x++) {

                        //Creamos una variable que almacena las horas de comienzo de cada clase
                        var start = []

                        //Recorremos cada dia de las clases
                        for (let z = 0; z < sortedDaysData[i][x].dias_clase.length; z++) {
                            //Las agregamos a la variable de almacenamiento de las horas
                            start.push(parseInt(sortedDaysData[i][x].dias_clase[z].de))
                        }


                        //Ahora validamos recorriendo las horas a cual pertenece cada una
                        for (let z = 0; z < h.length; z++) {
                            if (start.includes((z + 1))) {
                                h[z].push(sortedDaysData[i][x])
                                break
                            }
                        }

                    }

                    h.map((v, i) => {
                        v.map(v2 => {
                            aux2.push(v2)
                        })
                    })

                }

                setVariables(prev => ({
                    ...prev,
                    clases: aux2,
                    loading: false
                }))
            })
        }
    }, [])

    /**
     * FUNCIONES
     * PARA
     * LA
     * GENERACION
     * DEL
     * CORTE
    */

    const handleCreatePDF = () => {
        setConfirmCorte(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        getDataToPDF()
    }

    //Funcion que realiza la obtencion de datos
    const getDataToPDF = async () => {

        //Variables que cuenta las horas dadas por el profesor y las clases totales
        var horas = 0
        var conteo = 0

        //Obtenemos a los profesores de la academia
        var infoProfe = {}
        var allData = []
        var data = []
        var informacion = "<h1 style='width: 100%; font-family: sans-serif; text-align: center; font-size: 30px; margin-bottom: 50px;'> ASISTENCIAS AL " + new Date().getDate() + " de " + guessMonthNumb((new Date().getMonth() + 1)).toUpperCase() + " <h1>"

        //Recorremos cada profe que obtuvimos
        //Obtengo su nombre, su id y todas las clases que este registrado el profesor
        await getInfoProfe(location.state.data).then(r => {
            infoProfe = r
        })

        informacion += "<div>" +
            "<h2 style='width: 100%; font-family: sans-serif; text-align: center; border-radius: 10px; border: 2px " + main + " solid; color: " + main + "; font-size: 28px; padding: 10px; margin-bottom: 20px;'>" + infoProfe.nombre_profesor + "</h2>"

        //Obtenemos todos los registros de todas las clases, de forma desordenada
        for (let i = 0; i < infoProfe.clases.length; i++) {
            await getRegs(infoProfe.clases[i].id).then(r => {
                horas += r.horas

                for (let j = 0; j < r.data.length; j++) {
                    data.push(r.data[j])
                }
                allData.push({ id: infoProfe.clases[i].id, data: r.data })
                conteo += r.data.length
            })
        }

        //Ahora ordenamos los datos por fechas, de la menor a la mayor
        var sortedData = []
        for (let n = 0; n < data.length; n++) {
            if (data[n].fecha_clase == true || data[n].fecha_clase == false) {
                console.log(data[n])
            }
        }
        await sortData(data).then(r => {
            r.reverse()
            sortedData = r
        })

        var dias = []
        var currFecha = "";
        var index = 0, length = 0;
        var newSortedData = []

        for (let i = 0; i < sortedData.length; i++) {
            if (currFecha != sortedData[i].fecha_clase) {
                length++
                currFecha = sortedData[i].fecha_clase
            }
        }

        for (let i = 0; i < length; i++) {
            dias.push([])
        }

        currFecha = ""
        for (let i = 0; i < sortedData.length; i++) {
            if (currFecha != sortedData[i].fecha_clase) {
                dias[index].push(sortedData[i])

                currFecha = sortedData[i].fecha_clase
                if (currFecha != "") {
                    index++
                }
            } else {
                dias[index - 1].push(sortedData[i])
            }
        }

        //Una vez ordenadas por dias, ahora los ordenamos por horas
        for (let i = 0; i < dias.length; i++) {

            //Primero creamos una variable que contendra las horas de clase
            var h = hours.map((v, i) => [])

            for (let x = 0; x < dias[i].length; x++) {

                if (dias[i][x].idParent.split("-").length === 1 || dias[i][x].idParent.split("-")[2] === "TEMP") {
                    //Creamos una variable que almacena las horas de comienzo de cada clase
                    var start = []

                    //Recorremos cada dia de las clases
                    for (let z = 0; z < dias[i][x].dias_clase.length; z++) {
                        //Las agregamos a la variable de almacenamiento de las horas
                        start.push(parseInt(dias[i][x].dias_clase[z].de))
                    }

                    //Ahora validamos recorriendo las horas a cual pertenece cada una
                    for (let z = 0; z < h.length; z++) {
                        if (start.includes((z + 1))) {
                            h[z].push(dias[i][x])
                            break
                        }
                    }
                } else {
                    newSortedData.push(dias[i][x])
                }

            }

            h.map((v, i) => {
                v.map(v2 => {
                    newSortedData.push(v2)
                })
            })

        }

        sortedData = newSortedData

        //Mostramos los datos por fechas
        //Recorremos todas las clases obtenidas
        for (let i = 0; i < sortedData.length; i++) {

            const [year, month, dayArr] = sortedData[i].fecha_clase.split("-").map(Number);
            const date = new Date(year, month - 1, dayArr)

            // Arrays con los nombres de los días y meses en español
            const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
            const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

            const diaAux = diasSemana[date.getDay()];
            const diaNum = date.getDate();
            const mes = meses[date.getMonth()];
            const annio = date.getFullYear()

            //Imprimimos la fecha solamente si esta cambia
            if (i != 0) {
                if (sortedData[i].fecha_clase != sortedData[i - 1].fecha_clase) {
                    informacion += "<h2 style='width: 100%; font-family: sans-serif; text-align: center; border-bottom: 2px " + main + " solid; font-size: 28px; padding: 10px;'>" + diaAux + " " + diaNum + " de " + mes + " del " + annio + "</h2>"
                }
            } else {
                informacion += "<h2 style='width: 100%; font-family: sans-serif; text-align: center; border-bottom: 2px " + main + " solid; font-size: 28px; padding: 10px;'>" + diaAux + " " + diaNum + " de " + mes + " del " + annio + "</h2>"
            }

            informacion += "<p style='width: 100%; font-family: sans-serif; font-size: 22px; font-weight: bolder; color: " + main + ";'>" + sortedData[i].nombre_clase + "</p>" +
                "<p style='width: 100%; font-family: sans-serif; font-size: 18px; font-weight: lighter; margin-top: 0px;'>" + sortedData[i].descripcion_clase + "</p>"

            var clase = sortedData[i]
            if (sortedData[i].idParent.split("-").length === 1 || sortedData[i].idParent.split("-")[2] === "TEMP") {

                //Validamos si la clase fue dada sin ningun problema
                informacion += "<div style='margin-right: 50px; width: 100%; padding: 20px; border-radius: 10px; margin-bottom: 50px; border: 2px solid black; border-radius: 10px; margin-top: 5px;'>"
                if (clase.wasGiven === true) {
                    informacion += "<div style='background-color: #e2ffe2; margin-top: -10px; padding: 20px; border-radius: 10px; display: flex; align-items: center; justify-content: space-evenly; flex-direction: row;'>"

                    informacion += "<div style='width: 45%; display: flex; justify-content: center; align-items: center; flex-direction: column;'>" +
                        "<p style='font-family: sans-serif; font-size: 25px;'>ASISTENCIAS</p>" +
                        "<table style='width: 100%;'>"
                    for (let y = 0; y < clase.alumnos_clase.length; y++) {
                        informacion += "<tr><th  style='padding: 10px; margin-bottom: 5px; border-radius: 10px; font-family: sans-serif; font-weight: lighter; font-size: 18px; color: " + main + "; border: 2px solid black; border-radius: 5px;'>" + clase.alumnos_clase[y].nombre + "</th></tr>"
                    }
                    informacion += "</table></div>"

                    informacion += "<div style='width: 45%; display: flex; justify-content: center; align-items: center; flex-direction: column;'>" +
                        "<p style='font-family: sans-serif; font-size: 25px;'>REPOSICIONES</p>" +
                        "<table style='width: 100%; padding: 10px;'>"
                    for (let y = 0; y < clase.jugadores_reposicion.length; y++) {
                        informacion += "<tr><th  style='padding: 10px; margin-bottom: 5px; border-radius: 10px; font-family: sans-serif; font-weight: lighter; font-size: 18px; border: 2px solid black; border-radius: 5px;'>" + clase.jugadores_reposicion[y].nombre_jugador + "</th></tr>"
                    }
                    informacion += "</table></div>"
                    informacion += "</div>"
                    informacion += "<p style='margin-top: 20px; font-family: sans-serif; font-weight: bolder; font-size: 20px; text-align: center;'>ANOTACIONES</p>"
                    informacion += "<p style='margin-top: 10px; font-family: sans-serif; font-weight: lighter; font-size: 20px; text-align: center; border: 2px black dashed; padding: 20px; border-radius: 10px; font-style: italic;'>" + clase.comentarios_clase + "</p>"
                    informacion += "<p style='margin-top: 5px; font-family: sans-serif; font-weight: lighter; font-size: 22px; text-align: center;'>Fue impartida la leccion <span style='font-weight: bolder; color: " + main + ";'>" + clase.leccion_clase + "</span></p>"
                    informacion += "<p style='margin-top: 10px; font-family: sans-serif; font-weight: lighter; font-size: 22px; text-align: center;'>Duracion de la clase <span style='font-weight: bolder; color: " + main + ";'>" + clase.duracion_clase.toString() + "hrs</span></p>"
                } else {
                    informacion += "<p style='width: 100%; text-align: center; font-family: sans-serif; font-weight: bolder; font-size: 16px; font-weight: lighter;'>La clase no fue impartida por: <span style='font-weight: bolder'>" + (clase.reasons ? clase.reasons.toLowerCase() : "") + "</span></p>"
                    informacion += "<p style='width: 100%; text-align: center; font-family: sans-serif; font-weight: bolder; font-size: 16px; font-weight: bolder; margin-top: 20px'>Detalles</p>"
                    informacion += "<p style='width: 100%; text-align: center; font-family: sans-serif; font-weight: bolder; font-size: 16px; font-weight: lighter; margin-top: 10px'>'" +
                        (clase.details === "" ? "No hay detalles adicionales" : clase.details) +
                        "'</p>"
                }
                informacion += "</div>"

            } else if (sortedData[i].idParent.split("-")[2] === "EXT") {

                informacion += "<p style='font-family: sans-serif; font-size: 20px; font-weight: lighter; padding-left: 20px;'>La clase fue registrada el dia " + decomposeDate(clase.fecha_clase) + "</p>"

                //Validamos si la clase fue dada sin ningun problema
                informacion += "<div style='margin-right: 50px; width: 90%; padding: 20px; border-radius: 10px; margin-bottom: 50px; border: 2px solid black; border-radius: 10px;'>"

                informacion += "<div style='background-color: #e2ffe2; margin-top: -10px; padding: 20px; border-radius: 10px; display: flex; align-items: center; justify-content: space-evenly; flex-direction: row;'>"

                informacion += "<div style='width: 45%; display: flex; justify-content: center; align-items: center; flex-direction: column;'>" +
                    "<p style='font-family: sans-serif; font-size: 25px;'>ASISTENCIAS</p>" +
                    "<table style='width: 100%;'>"
                for (let y = 0; y < clase.jugadores_registrados.length; y++) {
                    informacion += "<tr><th  style='padding: 10px; margin-bottom: 5px; border-radius: 10px; font-family: sans-serif; font-weight: lighter; font-size: 18px; color: " + main + "; border: 2px solid black; border-radius: 5px;'>" + clase.jugadores_registrados[y].nombre + "</th></tr>"
                }
                for (let y = 0; y < clase.jugadores_noRegistrados.length; y++) {
                    informacion += "<tr><th  style='padding: 10px; margin-bottom: 5px; border-radius: 10px; font-family: sans-serif; font-weight: lighter; font-size: 18px; color: " + main + "; border: 2px solid black; border-radius: 5px;'>" + clase.jugadores_noRegistrados[y].nombre + "</th></tr>"
                }
                informacion += "</table></div>"

                informacion += "</div>"
                informacion += "<p style='margin-top: 20px; font-family: sans-serif; font-weight: bolder; font-size: 20px; text-align: center;'>ANOTACIONES</p>"
                informacion += "<p style='margin-top: -10px; font-family: sans-serif; font-weight: lighter; font-size: 20px; text-align: center; border: 2px black dashed; padding: 20px; border-radius: 10px; font-style: italic;'>" + clase.comentarios_clase + "</p>"
                informacion += "<p style='margin-top: -5px; font-family: sans-serif; font-weight: lighter; font-size: 22px; text-align: center;'>Fue impartida la leccion <span style='font-weight: bolder; color: " + main + ";'>" + (clase.leccion_clase === "" ? "No especificada" : clase.leccion_clase) + "</span></p>"
                informacion += "<p style='margin-top: -20px; font-family: sans-serif; font-weight: lighter; font-size: 22px; text-align: center;'>Duracion de la clase <span style='font-weight: bolder; color: " + main + ";'>" + clase.duracion_clase.toString() + "hrs</span></p>"

                informacion += "</div>"

            }

        }

        informacion += "<p style='margin-top: 20px; font-family: sans-serif; font-weight: bolder; font-size: 20px; text-align: center; color: " + main + ";'>Total de " + conteo + " clases / " + horas + "hrs</p>"

        generatePDF(informacion, allData)
    }
    //Nos sirve para obtener informacion del profe y todas sus clases
    const getInfoProfe = async (datos) => {
        var clases = []
        var infoProfe = {}

        await getDocs(query(collection(doc(db, ref), "Clases"), where("profesor_clase", "==", datos.id))).then(r => {
            r.docs.map(v => {
                if (v.id.split("-").length === 1 || v.id.split("-")[2] === "TEMP") {
                    clases.push({
                        id: v.id,
                        nombre_clase: v.data().nombre_clase,
                        descripcion_clase: v.data().descripcion_clase,
                        dias_clase: v.data().dias_clase
                    })
                } else {
                    clases.push({
                        id: v.id,
                        nombre_clase: v.data().nombre_clase,
                        descripcion_clase: v.data().descripcion_clase
                    })
                }
            })

            infoProfe = {
                ...datos,
                clases: clases
            }

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al obtener las clases del profesor", "error")
            }, 100)
        })

        return new Promise((resolve) => {
            resolve(infoProfe)
        })
    }
    //Nos sirve para obtener la referencia de los registros y para obtener cada uno de los subregistros de cada registro
    const getRegs = async (id) => {
        var regRef = null
        //Obtenemos la referencia de la clase
        await getDoc(doc(doc(db, ref), "Historial", id)).then(historial => {
            regRef = historial.ref
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al obtener las clases del profesor", "error")
            }, 100)
        })

        //Obtenemos cada subregistro de la referencia
        var data = []
        await getRegsData(regRef, id).then(r => {
            data = r
        })

        //Contamos las horas totales que se dieron
        var horas = 0
        data.map(v => {
            horas += v.duracion_clase ? parseInt(v.duracion_clase) : 0
        })

        return new Promise((resolve) => {
            resolve({ data, horas })
        })
    }
    //Funcion que obtiene los subregistros de cada referencia y a su vez actualiza las asistencias de los jugadores
    const getRegsData = async (regRef, id) => {
        var data = []
        var horas = 0
        await getDocs(query(collection(regRef, "Historial"))).then(registros => {
            registros.docs.map(v => {
                data.push({
                    id: v.id,
                    idParent: id,
                    ...v.data()
                })
            })

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al obtener los registros del historial", "error")
            }, 100)
        })

        return new Promise((resolve) => {
            resolve(data)
        })
    }
    //Funcion que ordena todos los datos
    const sortData = async (data) => {
        var sortedData = data

        //Validamos si se recogieron registros
        if (sortedData.length > 0) {
            //Ordenamos los registros del menor al mayor
            for (let i = 0; i < sortedData.length; i++) {
                for (let j = 0; j < sortedData.length - i - 1; j++) {
                    if (compareDates(sortedData[j].fecha_clase, sortedData[j + 1].fecha_clase) === 1) {
                        var temp = sortedData[j]
                        sortedData[j] = sortedData[j + 1]
                        sortedData[j + 1] = temp

                    }
                }
            }
        }

        return new Promise((resolve) => {
            resolve(sortedData)
        })
    }

    //Funcion que genera el PDF
    const generatePDF = (htmlString, registros) => {
        const opt = {
            margin: 0,
            filename: 'corte.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 1 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        }

        // Crea un div temporal
        const tempDiv = document.createElement('div')
        tempDiv.style.paddingLeft = "10px"
        tempDiv.style.paddingRight = "20px"
        tempDiv.innerHTML = htmlString
        document.body.appendChild(tempDiv)

        // Genera el PDF
        window.html2pdf()
            .from(tempDiv)
            .set(opt)
            .save()
            .then(async () => {
                document.body.removeChild(tempDiv);  // Limpia el div temporal después de generar el PDF

                await deleteData(registros).then(r => {
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    setTimeout(() => {
                        showMessage("Corte generado exitosamente", "success")
                        setTimeout(() => {
                            window.history.back()
                        }, 1500)
                    }, 100)
                }).catch(e => {
                    showMessage("Error al generar corte", "error")
                    setTimeout(() => {
                        window.history.back()
                    }, 1000)
                })
            })
    }

    //Funcion que elimina los registros de la base de datos
    const deleteData = async (registros) => {
        //Borramos los registros de la base de datos
        for (let i = 0; i < registros.length; i++) {
            const clase = registros[i].id

            //Obtenemos la referencia del documento
            await getDoc(doc(doc(db, ref), "Historial", clase)).then(r => {
                deleteRegs(r.ref, registros[i].data)
            })

            if (clase.split("-")[2] === "TEMP" || clase.split("-")[2] === "EXT") {
                //Borramos la clase del apartado de clases
                await deleteDoc(doc(doc(db, ref), "Clases", clase)).then(r => {
                    deleteDoc(doc(doc(db, ref), "Historial", clase))
                })
            }
        }
    }
    const deleteRegs = async (ref, data) => {
        for (let i = 0; i < data.length; i++) {
            await deleteDoc(doc(ref, "Historial", data[i].id))
        }
    }


    if (variables.loading) {
        return (
            <Loader loading={variables.loading} />
        )
    }

    if (!variables.loading)
        return (
            <div className='mainTeacherInfo'>

                <Snack />

                <Confirm
                    confirm={confirm}
                    setConfirm={setConfirm}
                    onHandle={onHandleEliminarProfesor}
                />

                <Confirm
                    confirm={confirmCorte}
                    setConfirm={setConfirmCorte}
                    onHandle={handleCreatePDF}
                />

                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.title,
                    paddingBottom: 0
                }}>{data.nombre_profesor} {data.apellido_p_profesor}</h2>
                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.text,
                    marginTop: -50,
                    marginBottom: 40,
                    fontSize: 18,
                    padding: 10,
                    paddingBottom: 20,
                    paddingTop: 0
                }}>{
                        localStorage.getItem("authToken") ?
                            JSON.parse(localStorage.getItem("authToken")).nombre_academia
                            : ""
                    }</h2>

                <Menu
                    academia={academia}
                    reference={ref}
                />

                <div className='contTeacherInfo'>

                    <div className='contOne' style={{
                        borderColor: main,
                        fontFamily: fontType.text
                    }}>
                        <p style={{
                            marginBottom: "20px",
                            fontFamily: fontType.subTitle,
                            fontWeight: 700,
                            fontSize: "18px"
                        }}>INFORMACION</p>
                        <p style={{
                            marginBottom: "5px"
                        }}><span style={{ fontWeight: 700 }}>Nombre:</span> {data.nombre_profesor}</p>
                        <p style={{
                            marginBottom: "5px"
                        }}><span style={{ fontWeight: 700 }}>Apellido:</span> {data.apellido_p_profesor}</p>
                        <p style={{
                            marginBottom: "30px",
                            textAlign: "center"
                        }}><span style={{ fontWeight: 700 }}>Correo:</span> {data.correo_profesor}</p>
                        <p style={{
                            marginBottom: "5px"
                        }}><span style={{ fontWeight: 700 }}>CLAVE DE ACCESO</span></p>
                        <p style={{
                            marginBottom: "30px",
                            textDecoration: "underline"
                        }}>{data.clave_profesor}</p>
                        <button style={{ fontFamily: fontType.subTitle }} onClick={() => {
                            setConfirm(prev => ({
                                ...prev,
                                title: "ELIMINAR PROFESOR",
                                text: "¿Estas seguro de eliminar el profesor permanentemente?",
                                show: true,
                            }))
                        }}>ELIMINAR</button>
                        <button style={{ fontFamily: fontType.subTitle, backgroundColor: main, marginTop: 10 }} onClick={() => {
                            setConfirmCorte(prev => ({
                                ...prev,
                                title: "GENERAR CORTE",
                                text: "¿Estas seguro de generar el corte del profesor?" +
                                    " Toma en cuenta que los registros seran borrados permanentemente.",
                                show: true,
                            }))
                        }}>GENERAR CORTE</button>
                    </div>

                    <div className='contTwo'>

                        <p style={{
                            marginBottom: "20px",
                            fontFamily: fontType.subTitle,
                            fontWeight: 700,
                            fontSize: "18px"
                        }}>CLASES</p>

                        {
                            variables.clases.map(v => {
                                return (
                                    <Link to="/classes/class" state={{
                                        ref: ref,
                                        id: v.id,
                                        academia: academia
                                    }} className='clase' style={{
                                        borderColor:
                                            v.nivel == "Etapa roja" ? "red" :
                                                v.nivel == "Etapa naranja" ? "orange" :
                                                    v.nivel == "Etapa verde" ? main :
                                                        v.nivel == "Clase D" ? "#ffdf00" :
                                                            v.nivel == "Clase C" ? "brown" :
                                                                v.nivel == "Clase B" ? "purple" :
                                                                    v.nivel == "Clase A" ? "blue" :
                                                                        v.nivel == "Profesional" ? "black" : null,
                                        borderWidth: "2px",
                                        borderStyle: "solid",
                                        fontFamily: fontType.text,
                                        textDecoration: "none",
                                        color: "black",
                                        position: "relative"
                                    }}>
                                        <p style={{
                                            marginBottom: 10,
                                            fontWeight: "bolder",
                                            fontSize: 18,
                                            textAlign: "center"
                                        }}>{v.nombre_clase}</p>
                                        <p>{v.descripcion_clase}</p>
                                        <p style={{
                                            position: "absolute",
                                            bottom: 5,
                                            left: 10,
                                            fontSize: 12
                                        }}>{v.numero_jugadores}/{v.limite_jugadores > 0 ? v.limite_jugadores : "∞"}</p>
                                    </Link>
                                )
                            })
                        }

                    </div>
                </div>

            </div>
        )
}

export default InfoTeacher